import { autoserialize, autoserializeAs } from 'cerialize';
import { VehicleInspectionItem } from './vehicle-inspection-item';

export class TransitProgramVehicleInspectionItem {
  @autoserialize
  id: number;

  @autoserialize
  transitProgramId: number;

  @autoserializeAs(VehicleInspectionItem)
  vehicleInspectionItem: VehicleInspectionItem;
}
